export abstract class FormElementBase {
  public value: any;
  public isDisabled: boolean;

  public onChange: any = (_: any) => {/**/};
  public onTouch: any = () => {/**/};

  change(value: any): void {
    this.value = value;
    this.onChange(value);
    this.onTouch();
  }

  writeValue(value: any): void {
    this.value = value;
    this.onChange(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }
}
